import {jQuery as $, lodash as _} from 'lib/shim';



const SELECTOR = '.atom-radiobutton';



class AtomRadiobutton {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._prime();
		}

		return $element;
	}



	_prime(){
		this._$element.makeStylable('stylable-radiobutton atom-inputlabel');

		if( this._$element.hasClass('atom-radiobutton') ){
			this._$element
				.removeClass('atom-radiobutton')
				.parent('.stylable-radiobutton')
				.addClass('atom-radiobutton')
				.end()
			;
		}

		if( this._$element.hasClass('error') ){
			this._$element
				.removeClass('error')
				.parent('.stylable-radiobutton')
				.addClass('error')
				.end()
			;
		}

		if( this._$element.is(':disabled') ){
			this._$element
				.parent('.stylable-radiobutton')
				.addClass('disabled')
				.end()
			;
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new AtomRadiobutton(app, $this));
	});

	return $elements;
}
